import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getCompanyPreferences } from '~/data/companyPreferences';
import { StoreState } from '~/reducer';
import { companyPreferencesStateSelector } from '~/selectors';
import { AppDispatch } from '~/store';

export const HandleCompanyPreferencesRequire: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const requiredCompanyPreferences = useSelector((state: StoreState) => {
    return companyPreferencesStateSelector(state).requiredCompanyPreferences;
  });

  React.useEffect(() => {
    if (!requiredCompanyPreferences || requiredCompanyPreferences.length) {
      (async () => {
        try {
          await dispatch(getCompanyPreferences(requiredCompanyPreferences));
        } catch {}
      })();
    }
  }, [dispatch, requiredCompanyPreferences]);

  return null;
};
